<template>
  <div>
    <spinner-component v-show="show_spinner"></spinner-component>
    <left-navbar id="side-menu" class="index-left" @show-side-menu="showSideMenu()" />
    <div @click="showSideMenu()" class="side-menu-background"></div>
    <div class="index-right">
      <div class="mobile-bg"></div>
      <div class="nav-header">
        <div class="show-side-menu" @click="showSideMenu(true)">
          <i class="fa-solid fa-bars"></i>
        </div>
        <div class="right-title"><span>MAX'Bx</span><small v-show="is_dev">&ensp;-&ensp;工程版</small></div>
        <div class="just-a-placeholder"></div>
      </div>
      <div class="nav-header">
        <div class="switch-data-type">
          <div v-show="picked_function === 'power-overview'">
            <a href="#" :class="{ 'selected': data_type === 'barChart' }" @click="switchDataType('barChart')">即時資料</a> |
            <a href="#" :class="{ 'selected': data_type === 'lineChart' }" @click="switchDataType('lineChart')">歷史資料</a>
          </div>
        </div>
        <div class="btn-group switch-billing-mode" v-show="picked_function === 'bill-query'">
          <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown">
            電力監測系統 {{ translateBillMode(bill_mode) }}
          </button>
          <div class="dropdown-menu dropdown-menu-right text-muted">
            <div class="pt-2 pl-3">
              <h4>電力監控系統 電費計算</h4>
              <small>(更新時間：103/05/27)</small>
            </div>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" type="button" v-for="value, index in bill_mode_list" :key="index"
              @click="switchBillMode(value.name)">
              {{ translateBillMode(value.name) }} <small>({{ value.explain }})</small>
            </button>
          </div>
        </div>

        <div class="set-date">
          <i class="fa-solid fa-calendar-days"></i>
          <flat-pickr v-model="set_date" :config="flatPickrConfig" placeholder="Select date"></flat-pickr>
        </div>
      </div>
      <div class="nav-header">
        <div class="switch-region">
          <div class="region-item" v-for="region, index in user_regions" :key="index"
            :class="{ 'active': selected_region.id === region.id }" @click="regionSwitch(region.id)">
            {{ region.name }}
          </div>
        </div>
      </div>

      <power-overview v-if="picked_function === 'power-overview'" />
      <bill-query v-if="request_date && picked_function === 'bill-query'" />

    </div>
  </div>
</template>

<script>
import DataExport from '../buttons/DataExport.vue';
import SelectCircuits from '../buttons/SelectCircuits.vue';
import PowerOverview from './PowerOverview.vue';
import BillQuery from './BillQuery.vue';
import { axiosMixins } from '../mixins/axiosErrorMessage';
import SpinnerComponent from '../layouts/SpinnerComponent.vue';
// date input plugin
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/light.css';
import LeftNavbar from '../layouts/LeftNavbar.vue';

export default {
  components: {
    DataExport,
    SelectCircuits,
    PowerOverview,
    BillQuery,
    SpinnerComponent,
    flatPickr,
    LeftNavbar
},
  mixins: [axiosMixins],
  data() {
    return {
      base_url: base_url,
      region_name: "",
      set_date: '',
      bill_mode_list: [
        { name: "residential", explain: "適用一般住家" },
        { name: "nonResidential", explain: "適用機關、學校等非營業性質的機構" },
        { name: "commercial", explain: "適用小型營業場所、辦公室等營業性質的機構" }
      ],
      bill_mode: '',
      spinner_timer: null,
    };
  },
  async mounted() {
    console.log('--m-home-- mounted');
    this.$store.commit('setShowSpinner', true);
    await this.$store.dispatch('setUserRegions');
    // 預設為區域中第一個電表
    const default_meter = this.$store.getters.selectedRegion.meters[0];
    await this.$store.dispatch('setRequestDate', default_meter.bx_mac);
    console.log('--m-home-- end set request date')
    await this.$store.dispatch('setSelectedMeter', default_meter.id);
  },
  computed: {
    is_dev() {
      if (process.env.NODE_ENV === 'production') {
        document.title = "MAX'Bx";
        return false;
      } else {
        document.title = "MAX'Bx - development";
        return true;
      }
    },
    show_spinner() {
      return this.$store.getters.showSpinner;
    },
    user_regions() {
      return this.$store.getters.userRegions;
    },
    selected_region() {
      return this.$store.getters.selectedRegion;
    },
    user_info() {
      return JSON.parse(localStorage.getItem('user_info'));
    },
    request_date() {
      this.set_date = this.$store.getters.requestDate;
      return this.$store.getters.requestDate;
    },
    data_type() {
      return this.$store.getters.dataType;
    },
    picked_function() {
      return this.$store.getters.pickedFunction;
    },
    flatPickrConfig() {
      const result = {
        ...this.$store.getters.flatPickrConfig,
        // locale: MandarinTraditional,
        disableMobile: "true",
        onChange: (selectedDates, dateStr, instance) => {
          console.log('--m-home-- flatpickr onChange');
          if (this.request_date !== dateStr) {
            this.$store.commit("setRequestDate", dateStr);
            this.$store.dispatch('setSelectedMeter');
          }
        }
      };
      console.log('--m-home-- flatPickrConfig', result);

      return result
    },
    billMode() {
      return this.$store.getters.billMode;
    }
  },
  watch: {
    billMode() {
      console.log('--m-home-- billMode changed');
      this.bill_mode = this.billMode;
    },
    show_spinner() {
      if (this.spinner_timer) {
        clearInterval(this.spinner_timer);
        this.spinner_timer = null;
      }
      // refresh page every 30 sec if still spinning
      if (this.show_spinner) {
        this.spinner_timer = setInterval(() => {
          window.location.reload();
        }, 15000);
      }
    },
    deep: true,
  },
  methods: {
    userLogOut() {
      axios.get(base_url + "/api/logout")
        .then((response) => {
          localStorage.removeItem('token');
          localStorage.removeItem('user_info');
          this.$store.commit('setLoginCurrentContent', 'login');
          this.$router.push({ name: "login" });
        }).catch(error => this.axiosMessage(error));
    },
    pickFunction(function_name) {
      console.log('--m-home-- function switch');
      console.log('--m-home-- side menu close');
      this.showSideMenu(false);
      this.$store.commit('setPickedFunction', function_name);
    },
    switchDataType(type) {
      console.log('--m-home-- data type switch');
      this.$store.commit('setHistoricalDataTimeFormat', 'day');
      this.$store.commit('setDataType', type);
    },
    async regionSwitch(region_id) {
      console.log('--m-home-- region switch');
      if (this.selected_region.id !== region_id) {
        this.$store.commit('setSelectedRegion', region_id);
        await this.$store.dispatch('setRequestDate', this.$store.getters.selectedRegion.meters[0].bx_mac);
        // 預設為區域中第一個電表
        console.log('--m-home-- end set request date after region switch');
        await this.$store.dispatch('setSelectedMeter', this.$store.getters.selectedRegion.meters[0].id);
      }
    },
    translateBillMode(bill_mode) {
      switch (bill_mode) {
        case "nonResidential":
          return "非營業用電";
        case "commercial":
          return "營業用電";
        default:
          return "住宅用電";
      }
    },
    switchBillMode(bill_mode) {
      if (this.billMode !== bill_mode) {
        console.log('--m-home-- call switchBillMode api');
        axios.patch(base_url + "/api/regions/bill-mode/" + this.selected_region.id, {
          "bill_mode": bill_mode
        }).then((response) => {
          this.$store.dispatch('setUserRegions');
        }).catch(error => this.axiosMessage(error));
      }
    },
    showSideMenu(bool) {
      if (bool) {
        this.$el.querySelector('#side-menu').classList.add('side-menu-width');
        this.$el.querySelector('.side-menu-background').style.display = 'block';
      } else {
        this.$el.querySelector('#side-menu').classList.remove('side-menu-width');
        this.$el.querySelector('.side-menu-background').style.display = 'none';
      }
    }
  }
};
</script>

<style>
.set-date .form-control:disabled,
.set-date .form-control[readonly],
.set-date .form-control:focus {
  background-color: transparent;
  opacity: 1;
  box-shadow: none;
  cursor: pointer;
}

.set-date .form-control {
  color: var(--bx-blur);
  border: none;
  width: fit-content;
  width: auto;
  max-width: 9.5rem;
  min-width: 8rem;
}

.flatpickr-months .flatpickr-month,
.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-weekdays,
.flatpickr-weekday {
  background: var(--bx-body-background);
}

.dayContainer .flatpickr-day.selected,
.dayContainer .flatpickr-day:hover {
  color: #fff;
  background: var(--bx-dark-blue);
  border-color: var(--bx-dark-blue);
}
</style>

<style scoped>
a {
  text-decoration: none;
}

.side-menu-background {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.158);
  z-index: 9998;
}

.index-left {
  padding: 0 calc(20% * 0.12) 0 calc(20% * 0.12);
  position: absolute;
  height: 100vh;
  background-color: var(--bx-dark-blue);
  display: flex;
  flex-direction: column;
  width: 65vw;
  left: -65vw;
  transition: 0.5s;
  color: var(--bx-blur);
  text-align: center;
  z-index: 9999;
}

.side-menu-width {
  left: 0;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.493);
}

.index-right {
  height: 100vh;
  width: 100%;
  color: var(--bx-blur);
}

.index-right a {
  color: var(--bx-blur);
}

.index-right .mobile-bg {
  position: absolute;
  background-color: var(--bx-dark-blue);
  width: 100%;
  height: 25vh;
  z-index: -99999;
}

.index-right .nav-header {
  display: flex;
  align-items: center;
  height: 5.5vh;
  font-size: .8rem;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
}

.index-right .nav-header .show-side-menu {
  display: flex;
  align-items: center;
  height: 100%;
  width: 3rem;
  font-size: 1.5rem;
  color: var(--bx-unselected-btn);
}

.index-right .nav-header .switch-data-type .selected {
  font-weight: bolder;
  color: white;
}

.index-right .nav-header .set-date {
  display: flex;
  align-items: center;
}

.index-right .nav-header .set-date svg {
  font-size: 1rem;
}

.index-right .nav-header .right-title {
  display: flex;
  align-items: center;
}

.index-right .nav-header .right-title>span {
  font-size: 1.5rem;
  color: white;
}

.index-right .nav-header .switch-region {
  height: 100%;
  display: flex;
  align-items: center;
}

.index-right .nav-header .switch-region .region-item {
  padding: .8rem;
  padding-bottom: .1rem;
  cursor: pointer;
}

.index-right .nav-header .switch-region .active {
  color: white;
  border-bottom: 2px solid var(--bx-green);
}

.index-right .nav-header .switch-billing-mode .btn {
  font-size: .9em;
  /* color: white; */
}

.index-right .nav-header .switch-billing-mode .dropdown-menu .dropdown-item {
  padding: .25rem 1rem;
}
</style>
